<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="data-list"
            :url="url"
            :columns="columnList"
            :columnConfig="true"
            :buttons="[]"
            dialogWidth="90%"
            :tableHeight="screenHeight - 195"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default', label: '详情' }"
            @LoadDetail="LoadDetail"
            @gotoDocument="gotoDocument"
            @gotoAnalgesic="gotoAnalgesic"
        >
            <slot slot="filter">
                <el-col :md="2" :xl="2">手术时间:</el-col>
                <el-col :md="8" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :xl="3">
                    <item-input type="select" v-model="dic_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
                </el-col>
                <el-col :md="5" :xl="3">
                    <item-input type="select" v-model="dic_section_id" :options="section_auth" :clearable="true" placeholder="请选择科室"></item-input>
                </el-col>
            </slot>
            <div slot="table-title" class="align-left">&nbsp;术后镇痛患者共计：{{ surgeriesList.length }}例</div>
        </crud-facecade>
        <cus-dialog class="table-h360" title="详情" :visible.sync="Analgesicdetail.dialogFormVisible" :close-on-click-modal="false" width="80%" @confirm="closewbase()">
            <cus-form :columns="from1columnList" :data="Analgesicdetail.fromdata"> </cus-form>
            <ListView :columns="listcolumnList" :rowNoStyle="true" :datalist="Analgesicdetail.listdata"></ListView>
            <cus-form :columns="Analgesicdetail.from2columnList" :data="Analgesicdetail.fromdata"> </cus-form>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `AnalgesicIndex`,
    components: {},
    props: {},
    data() {
        return {
            title: `镇痛列表`,
            rdate: [
                this.$moment()
                    .add(-1, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`),
                this.$moment()
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            dic_section_id: undefined,
            o_dic_ward_id: undefined,
            issetoperatingward: false,
            surgeriesList: [],
            Analgesicdetail: {
                dialogFormVisible: false,
                from2columnList:
                    [
                        {
                            type: `string`,
                            prop: `analgesia_summary`,
                            label: `镇痛总结`,
                            isCreatable: true,
                            readonly: true,
                            isEditable: true,
                            colspan: 24
                        },
                        {
                            type: `string`,
                            prop: `complication`,
                            label: `并发症`,
                            isCreatable: true,
                            readonly: true,
                            isEditable: true,
                            colspan: 12
                        },
                        {
                            type: `string`,
                            prop: `adverse_reaction`,
                            label: `不良反应`,
                            isCreatable: true,
                            readonly: true,
                            isEditable: true,
                            colspan: 12
                        },
                        {
                            type: `textarea`,
                            prop: `remark`,
                            label: `备注`,
                            config: {
                                minRows: 2
                            },
                            isCreatable: true,
                            isEditable: true,
                            readonly: true,
                            colspan: 24
                        }
                    ],
                fromdata: {},
                listdata: []
            },
            url: {
                baseURL: `/api/AcisSystem/AnalgesicRecord`,
                get: () => {
                    return this.loadSurgeries()
                },
                getOne: row => {
                    return this.loadOne(row)
                }
            },
            analgesicSearchTimeConfig: this.$root.AnalgesicSearchTimeConfig
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `active_ward`, `drug/drug_unit`, `sys_enums`, `operation_ward_auth`, `section_auth`, `business`, `screenHeight`]),
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && this.active_ward.code == `手术区`) {
                    this.o_dic_ward_id = this.active_ward.origion
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    sortable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`byvisit.visit_no`),
                    width: `100`,
                    isListable: true,
                    queryable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    width: `50`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `height`,
                    label: `身高(cm)`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `weight`,
                    label: `体重(kg)`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `operation_begin`,
                    label: `手术开始时间`,
                    sortable: true,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `operation_end`,
                    label: `手术结束时间`,
                    sortable: true,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `180`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anes_doctor`,
                    label: `麻醉医生`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `multiselect`,
                    prop: `enum_analgesic_modes`,
                    label: `镇痛方式`,
                    isListable: true,
                    width: `180`,
                    options: this.sys_enums.Enum_AnalgesicMode || []
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    fixed: `right`,
                    label: `操作`,
                    width: `130`,
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        return [
                            {
                                class: `is-plain`,
                                label: `随访`,
                                icon: ``,
                                type: `primary`,
                                emit: `gotoDocument`,
                                permission: `default`
                            },
                            {
                                class: `is-plain`,
                                label: `详情`,
                                icon: ``,
                                type: `primary`,
                                emit: `gotoAnalgesic`,
                                permission: `default`
                            }
                        ]
                    }
                }
            ]
        },
        from1columnList() {
            return [{
                type: `multiselect`,
                prop: `enum_analgesic_modes`,
                label: `镇痛方式`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                options: this.sys_enums.Enum_AnalgesicMode || [],
                colspan: 12
            },
            {
                type: `string`,
                prop: `analgesia_pump_brand`,
                label: `镇痛泵品牌`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 12
            },
            {
                type: `datetime`,
                prop: `analgesia_pump_start_time`,
                label: `开机时间`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `datetime`,
                prop: `analgesia_pump_end_time`,
                label: `停止时间`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `float`,
                prop: `total_capacity`,
                label: `总容量(ml)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `float`,
                prop: `continuous_dose`,
                label: `持续剂量(ml/h)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `float`,
                prop: `single_dose`,
                label: `单次剂量(ml)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `integer`,
                prop: `pcatimes`,
                label: `PCA次数`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `float`,
                prop: `first_dose`,
                label: `首次剂量(ml)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `float`,
                prop: `maximum_dose_per_hour`,
                label: `最大剂量(ml/h)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `integer`,
                prop: `lock_time`,
                label: `锁定时间(min)`,
                isCreatable: true,
                isEditable: true,
                readonly: true,
                colspan: 6
            },
            {
                type: `string`,
                prop: `recipe_remarks`,
                label: `配方备注`,
                isCreatable: true,
                readonly: true,
                isEditable: true,
                colspan: 18
            }
            ]
        },
        listcolumnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    isKey: true,
                    label: `编号`
                },
                {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true,
                    options: `/api/AcisSystem/Drug/SearchAnalgesics`,
                    readonly: true
                },
                {
                    type: `float`,
                    prop: `dosage`,
                    label: `剂量`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `select`,
                    prop: `dic_unit_id`,
                    label: `单位`,
                    isListable: true,
                    options: this[`drug/drug_unit`],
                    readonly: true
                }
            ]
        }
    },
    created() {
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.loadAnalgesicSearchTimeConfig()
    },
    methods: {
        loadAnalgesicSearchTimeConfig() {
            let beginTime = this.$moment().add(-1, `days`).format(`YYYY/MM/DD HH:mm:ss`)
            if (this.analgesicSearchTimeConfig) {
                let configs = this.analgesicSearchTimeConfig.split(`|`)
                if (configs.length >= 2) {
                    beginTime = this.$moment().add(parseInt(configs[0]), `days`).format(`YYYY/MM/DD`) + ` ${configs[1]}`
                }
            }
            console.log(`beginTime`)
            console.log(beginTime)
            let endTime = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            if (this.analgesicSearchTimeConfig) {
                let configs = this.analgesicSearchTimeConfig.split(`|`)
                if (configs.length == 3) {
                    endTime = this.$moment(beginTime).add(parseInt(configs[2]), `hours`).format(`YYYY/MM/DD HH:mm:ss`)
                }
            }
            this.rdate = [beginTime, endTime]
        },
        gotoDocument({ row }) {
            console.log(this.business)
            let menuName = `document2`
            let r = _.find(this.business, t => {
                return t.business_level == `M004` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                let rurl = menuInfo.url
                if (rurl) {
                    let docId = this.$root.DOCUMENT[`ZTSF001`]
                    rurl += rurl.indexOf(`?`) > -1 ? `&` : `?`
                    rurl = `${rurl}&docId=${docId}&isOnly=1`
                    menuInfo.url = rurl
                    this.openUrl(menuInfo, row.id)
                } else {
                    console.log(`菜单`, menuInfo)
                    this.$message.error(`请检查患者文书菜单配置`)
                }
            }
        },
        gotoAnalgesic({ row }) {
            console.log(this.business)
            let menuName = `analgesic`
            let r = _.find(this.business, t => {
                return t.business_level == `M003` && t.location == menuName
            })
            if (!r) {
                this.$message.error(`患者管理没有配置 ${menuName} 页面,请配置菜单和工作栏`)
            } else {
                let menuInfo = _.cloneDeep(r)
                this.openUrl(menuInfo, row.id)
            }
        },
        openUrl(menuInfo, surgeryId) {
            let that = this
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgeryId}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(surgeryId, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${surgeryId}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                let token = sessionStorage.getItem(`token`)
                let r = `${routeUrl.href}&token=${encodeURIComponent(token)}`
                // 打开新页面并传递凭据
                // eslint-disable-next-line no-undef
                if (typeof cordova != `undefined`) {
                    // eslint-disable-next-line no-undef
                    that.newWindow = cordova.InAppBrowser.open(
                        r,
                        `_blank`,
                        `toolbar=no,zoom=no`
                    )

                    // 添加事件监听
                    that.newWindow.addEventListener(`exit`, this.onExit)
                } else {
                    var w = this.screenWidth - 10
                    var h = this.screenHeight - 10
                    that.newWindow = window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
                    if (!that.windowsOpenLoop) {
                        that.windowsOpenLoop = setInterval(() => {
                            if (that.newWindow.closed) {
                                clearInterval(that.windowsOpenLoop)
                                that.windowsOpenLoop = ``
                                that.loadSurgeries() // 重新请求页面数据
                            }
                        }, 1000)
                    }
                }
            }
        },
        onExit() {
            // 在需要的时候移除事件监听
            this.loadSurgeries() // 重新请求页面数据
            this.newWindow.removeEventListener(`exit`, this.onExit)
        },
        loadSurgeries() {
            // 加载计费患者
            if (
                this.$moment(this.rdate[0])
                    .add(60, `days`)
                    .isBefore(this.$moment(this.rdate[1]))
            ) {
                this.$message.warning(`最多查询60天`)
                return Promise.resolve([])
            }
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/AnalgesicRecord/GetByDate?sectionId=${this.dic_section_id || 0}&from=${this.rdate[0]}&to=${this.rdate[1]}`)
                req.then(data => {
                    let r = _.filter(data, d => {
                        return this.dic_ward_id == d.dic_operating_ward_id
                    })
                    // 镇痛方式加载异常
                    _.map(data, d => {
                        var ids = d.enum_analgesic_mode ? d.enum_analgesic_mode.split(`,`) : []
                        let modes = ids.map(item => {
                            return +item
                        })
                        d.enum_analgesic_modes = modes
                        return d
                    })
                    this.surgeriesList = r
                    resolve(r)
                }).catch(e => reject(e))
            })
        },
        LoadDetail(row) {
            console.log(row.row.id)
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/AnalgesicRecord/GetBySurgeryId?surgeryId=${row.row.id}`)
                req.then(data => {
                    console.log(data)
                    var ids = data.enum_analgesic_mode ? data.enum_analgesic_mode.split(`,`) : []
                    let modes = ids.map(item => {
                        return +item
                    })
                    // 镇痛方式加载异常
                    data.enum_analgesic_modes = modes
                    this.Analgesicdetail.dialogFormVisible = true
                    this.Analgesicdetail.fromdata = data
                    this.Analgesicdetail.listdata = data.analgesicsDetails || []
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        ReloadListData() {
            this.$refs[`data-list`].ReloadListData()
        },
        closewbase() {
            this.Analgesicdetail.dialogFormVisible = false
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.chargeType = newUrl.query.charge_type
            this.ReloadListData()
        },
        dic_ward_id: function() {
            this.ReloadListData()
        },
        rdate: function() {
            this.ReloadListData()
        },
        dic_section_id: function() {
            this.ReloadListData()
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Analgesic/AnalgesicIndex.vue